<template>
  <div :class="{'compact-mode': isCompactMode}">
    <div>
      <el-card class="box-card">
        <div slot="header" class="subjectTitle">
          <div class="subjectName">
            <span class="question-number" v-if="subjectId !=null">{{ subjectId }}.</span>
            <div class="editor-content-view question-title-content">
              <div v-html="processedTitle"></div>
            </div>
          </div>
        </div>

        <p v-if="haveAnswer" class="content" style="padding-bottom: 10px"><span>我的答案:</span></p>
        <div>

          <div v-if="isScratchUnansweredAnswer"
               class="uploaded-file-info unanswered-file-info">
            <p class="content2">作答状态:</p>
            <div class="file-display">
              <div class="file-info">
                <i class="el-icon-warning-outline"></i>
                <span class="file-name">未作答（未上传代码文件）</span>
              </div>

            </div>
          </div>
          <div v-else-if="haveAnswer && questionBody.answerInfo !=null && questionBody.answerInfo.userAnswerFileId"
               class="uploaded-file-info">
            <p class="content2">上传的文件:</p>
            <div class="file-display">
              <div class="file-info">
                <i class="el-icon-document"></i>
                <span class="file-name">{{ questionBody.answerInfo.answerFile.oldFileName }}</span>
              </div>
              <a
                  :href="'/answer/' + encodeURIComponent(questionBody.answerInfo.answerFile.fileName)"
                  :download="questionBody.answerInfo.answerFile.oldFileName"
                  class="download-link"
              >
                下载文件
              </a>
            </div>
          </div>

          <div v-if="questionBody.langCode === 'Scratch' && !haveAnswer">
            <div class="upload-title">上传代码文件:</div>
            <el-upload
                class="upload-demo"
                drag
                action="/wancode/exam/userAnswerFile"
                :auto-upload="false"
                :on-change="handleFileChange"
                :file-list="fileList"
                :limit="1"
                :data="uploadData"
                :on-success="handleUploadSuccess"
                :on-error="handleUploadError"
                :on-remove="handleFileRemove"
                :show-file-list="true"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em>（只能上传一个文件）</div>
              <div class="el-upload__tip" slot="tip">提示“ 文件上传成功！”后，再点击“提交试卷”</div>
            </el-upload>
          </div>
          <div v-else-if="questionBody.langCode !== 'Scratch'" class="monaco-editor-wrapper">
          <!-- Monaco Editor 带工具栏 -->
            <!-- 顶部工具栏 -->
            <div class="editor-toolbar">
              <div class="toolbar-left">
                <span class="lang-tag">{{ currentLang }}</span>
              </div>
              <div class="toolbar-right">
                <span class="toolbar-btn" @click="handleAICode">
                  <i class="el-icon-cpu"></i> AI写代码
                </span>
                <span class="toolbar-btn" @click="handleCopyCode">
                  <i class="el-icon-document-copy"></i> 复制
                </span>
                <span class="toolbar-btn run-btn" @click="handleRunCode">
                  <i class="el-icon-video-play"></i> 运行
                </span>
              </div>
            </div>
            <!-- Monaco Editor -->
            <div ref="monacoEditorContainer" class="monaco-editor-container"></div>
          </div>
        </div>

        <div v-if="haveAnswer" class="answer-style">

          <!--					<p class="content"><span>标准答案:</span><span v-html="questionBody.correct"></span></p>-->
          <div style="display: flex;">
            <span class="content"><span>结果: </span></span>
            <el-tag size="mini" v-if="questionBody.answerInfo.doRight" type="success"
                    style="margin-top: 20px;">
              正确
            </el-tag>
            <el-tag size="mini" v-if="!questionBody.answerInfo.doRight" type="danger"
                    style="margin-top: 20px;">
              错误
            </el-tag>
          </div>
          <p class="content">
            <span>得分:  </span>{{ questionBody.answerInfo.score }} / {{ questionBody.score }}
            <span style="color: red;margin-left: 10px">
            提示：编程题属于主观题范畴，在当前的评价体系中，其默认比重为60%。
            </span>
          </p>

          <p class="content">
            <span>得分率:</span>60%
          </p>
          <div style="display: flex;">
            <p class="content"><span>难度:  </span></p>
            <el-rate v-model="questionBody.difficult" style="margin-top: 20px;" disabled=""></el-rate>
          </div>
          <div>
            <p class="content" style="padding-bottom: 10px"><span>参考答案:</span></p>
            <!-- Scratch 编程题使用普通文本展示 -->
            <div v-if="questionBody.langCode === 'Scratch'" class="scratch-answer">
              <span v-html="content"></span>
            </div>
            <!-- 其他语言使用 Monaco Editor -->
            <div v-else class="monaco-editor-wrapper">
              <div class="editor-toolbar">
                <div class="toolbar-left">
                  <span class="lang-tag">{{ currentLang }}</span>
                </div>
                <div class="toolbar-right">
                  <span class="toolbar-btn disabled">
                    <i class="el-icon-cpu"></i> AI写代码
                  </span>
                  <span class="toolbar-btn" @click="handleCopyAnswer">
                    <i class="el-icon-document-copy"></i> 复制
                  </span>
                  <span class="toolbar-btn run-btn disabled">
                    <i class="el-icon-video-play"></i> 运行
                  </span>
                </div>
              </div>
              <div ref="answerEditorContainer" class="monaco-editor-container"></div>
            </div>
          </div>
          <p class="content"><span>解析:</span><span v-html="processedAnalyze"></span></p>

          <div class="action-buttons">
            <!-- 解析补充功能暂时关闭 -->
            <span class="action-btn" @click="openAmendDialog()">
              <i class="el-icon-warning-outline"></i> 纠错
            </span>
            <span class="action-btn" @click="collectQuestion()">
              <i class="el-icon-star-off"></i> 收藏
            </span>
          </div>
        </div>
      </el-card>
    </div>
    <amendDialog v-if="!isWrongBookPage" :amendDialogShow="amendDialogShow"
                 :questionId="this.questionBody.id"
                 @closeAmendDialog="closeAmendDialog">
    </amendDialog>

    <analysisDialog v-if="!isWrongBookPage" :analysisDialogShow="analysisDialogShow" :questionId="this.questionBody.id"
                    @closeAnalysisDialog="closeAnalysisDialog"></analysisDialog>
  </div>
</template>

<script>
import amendDialog from "@/components/amendDialog.vue"
import analysisDialog from "@/components/analysisDialog.vue"
import request from '@/utils/request.js'
import * as monaco from 'monaco-editor'

export default {
  components: {
    analysisDialog,
    amendDialog,
    editor: require('vue2-ace-editor')
  },
  props: {
    subjectId: {
      type: Number,
      default: 1
    },
    isDis: {
      type: Boolean,
      default: false
    },
    questionBody: {
      type: Object,
      default: () => ({})
    },
    haveAnswer: {
      type: Boolean,
      default: false
    },
    chooseItem: {
      type: String,
      default: ""
    }
  },
  computed: {
    // 处理题目标题中的图片 URL
    processedTitle() {
      return this.$processImages(this.questionBody.title);
    },
    // 处理解析中的图片 URL
    processedAnalyze() {
      return this.$processImages(this.questionBody.analyze);
    },
    // 判断是否为紧凑模式（试卷页面）
    isCompactMode() {
      return this.$route.path === '/testPaperDetails';
    },
    // 判断是否在wrongBook页面
    isWrongBookPage() {
      return this.$route.path === '/wrongBook';
    },
    // Scratch 文件题未上传时，提交记录中会以“未作答”回显
    isScratchUnansweredAnswer() {
      const answerInfo = this.questionBody.answerInfo || {};
      return this.haveAnswer &&
          this.questionBody.langCode === 'Scratch' &&
          !answerInfo.userAnswerFileId &&
          (answerInfo.content === '未作答' || answerInfo.content === '代码文件');
    },
    // 根据题目语言码返回显示的语言名称
    currentLang() {
      const langMap = {
        'Python': 'python',
        'C': 'cpp',
        'Cpp': 'cpp',
        'Java': 'java',
        'JavaScript': 'javascript',
        'Scratch': 'scratch'
      }
      return langMap[this.questionBody.langCode] || 'python'
    },
    // Monaco Editor 语言映射
    monacoLang() {
      const langMap = {
        'Python': 'python',
        'C': 'cpp',
        'Cpp': 'cpp',
        'Java': 'java',
        'JavaScript': 'javascript'
      }
      return langMap[this.questionBody.langCode] || 'python'
    }
  },
  mounted() {
    if (this.haveAnswer) {
      this.content = this.questionBody.correct
      this.myAnswer = this.questionBody.answerInfo.content
    } else {
      if (this.questionBody.langCode === 'Scratch') {
        this.myAnswer = '代码文件'
      }
    }
    // 初始化完成后，取消初始化标记
    this.$nextTick(() => {
      this.isInitializing = false
    })
    // 初始化 Monaco Editor
    this.$nextTick(() => {
      this.initMonacoEditor()
      // 如果有答案，初始化参考答案编辑器
      if (this.haveAnswer) {
        this.initAnswerEditor()
      }
      // 为 pre 标签添加复制按钮
      this.addCopyButtonsToPreTags()
    })
  },
  beforeDestroy() {
    // 销毁 Monaco Editor 实例
    if (this.monacoEditor) {
      this.monacoEditor.dispose()
      this.monacoEditor = null
    }
    if (this.answerEditor) {
      this.answerEditor.dispose()
      this.answerEditor = null
    }
  },
  methods: {
    // 初始化 Monaco Editor
    initMonacoEditor() {
      const container = this.$refs.monacoEditorContainer
      if (!container || this.questionBody.langCode === 'Scratch') return

      // 创建 Monaco Editor 实例
      this.monacoEditor = monaco.editor.create(container, {
        value: this.myAnswer || this.getDefaultCode(),
        language: this.monacoLang,
        theme: 'vs-dark',
        fontSize: 16,
        lineNumbers: 'on',
        minimap: {enabled: false},
        scrollBeyondLastLine: false,
        automaticLayout: true,
        tabSize: 4,
        wordWrap: 'on',
        folding: true,
        lineHeight: 24,
        padding: {top: 10, bottom: 10},
        scrollbar: {
          vertical: 'auto',
          horizontal: 'auto',
          verticalScrollbarSize: 10,
          horizontalScrollbarSize: 10,
          alwaysConsumeMouseWheel: false
        }
      })

      // 初始化高度
      this.updateEditorHeight(this.monacoEditor, container)

      // 监听内容变化
      this.monacoEditor.onDidChangeModelContent(() => {
        this.myAnswer = this.monacoEditor.getValue()
        this.updateEditorHeight(this.monacoEditor, container)
      })
    },
    // 初始化参考答案 Monaco Editor
    initAnswerEditor() {
      const container = this.$refs.answerEditorContainer
      if (!container || this.questionBody.langCode === 'Scratch') return

      // 创建参考答案 Monaco Editor 实例（只读）
      this.answerEditor = monaco.editor.create(container, {
        value: this.content || '',
        language: this.monacoLang,
        theme: 'vs-dark',
        fontSize: 16,
        lineNumbers: 'on',
        minimap: {enabled: false},
        scrollBeyondLastLine: false,
        automaticLayout: true,
        tabSize: 4,
        wordWrap: 'on',
        folding: true,
        lineHeight: 24,
        readOnly: true,
        padding: {top: 10, bottom: 10},
        scrollbar: {
          vertical: 'auto',
          horizontal: 'auto',
          verticalScrollbarSize: 10,
          horizontalScrollbarSize: 10,
          alwaysConsumeMouseWheel: false
        }
      })

      // 初始化高度
      this.updateEditorHeight(this.answerEditor, container)
    },
    // 根据代码行数动态调整编辑器高度（自动展开全部内容，无滚动条）
    updateEditorHeight(editor, container) {
      const lineHeight = 24
      const padding = 20 // 上下 padding
      const minHeight = 350
      const lineCount = editor.getModel().getLineCount()
      const contentHeight = lineCount * lineHeight + padding
      const newHeight = Math.max(contentHeight, minHeight)
      container.style.height = newHeight + 'px'
      editor.layout()
    },
    // 获取默认代码模板
    getDefaultCode() {
      return ''
    },
    // AI写代码
    handleAICode() {
      this.$message.info('AI写代码功能开发中...')
    },
    // 复制代码
    handleCopyCode() {
      const code = this.monacoEditor ? this.monacoEditor.getValue() : this.myAnswer
      if (navigator.clipboard) {
        navigator.clipboard.writeText(code).then(() => {
          this.$message.success('代码已复制到剪贴板')
        }).catch(() => {
          this.$message.error('复制失败')
        })
      } else {
        // 回退方案
        const textarea = document.createElement('textarea')
        textarea.value = code
        document.body.appendChild(textarea)
        textarea.select()
        document.execCommand('copy')
        document.body.removeChild(textarea)
        this.$message.success('代码已复制到剪贴板')
      }
    },
    // 复制参考答案
    handleCopyAnswer() {
      const code = this.answerEditor ? this.answerEditor.getValue() : this.content
      if (navigator.clipboard) {
        navigator.clipboard.writeText(code).then(() => {
          this.$message.success('参考答案已复制到剪贴板')
        }).catch(() => {
          this.$message.error('复制失败')
        })
      } else {
        const textarea = document.createElement('textarea')
        textarea.value = code
        document.body.appendChild(textarea)
        textarea.select()
        document.execCommand('copy')
        document.body.removeChild(textarea)
        this.$message.success('参考答案已复制到剪贴板')
      }
    },
    // 运行代码
    handleRunCode() {
      this.$message.info('运行功能开发中...')
    },
    // 为 pre 标签添加复制按钮
    addCopyButtonsToPreTags() {
      const container = this.$el.querySelector('.editor-content-view')
      if (!container) return

      const preTags = container.querySelectorAll('pre')
      preTags.forEach((pre) => {
        // 避免重复添加
        if (pre.parentNode.classList.contains('pre-wrapper')) return

        // 创建包装器
        const wrapper = document.createElement('div')
        wrapper.className = 'pre-wrapper'

        // 创建复制按钮
        const copyBtn = document.createElement('span')
        copyBtn.className = 'pre-copy-btn'
        copyBtn.innerHTML = '<i class="el-icon-document-copy"></i> 复制'
        copyBtn.onclick = () => this.copyPreContent(pre)

        // 包装 pre 元素
        pre.parentNode.insertBefore(wrapper, pre)
        wrapper.appendChild(pre)
        wrapper.appendChild(copyBtn)
      })
    },
    // 复制 pre 标签内容
    copyPreContent(preElement) {
      const text = preElement.textContent || preElement.innerText
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(() => {
          this.$message.success('内容已复制到剪贴板')
        }).catch(() => {
          this.$message.error('复制失败')
        })
      } else {
        const textarea = document.createElement('textarea')
        textarea.value = text
        document.body.appendChild(textarea)
        textarea.select()
        document.execCommand('copy')
        document.body.removeChild(textarea)
        this.$message.success('内容已复制到剪贴板')
      }
    },
    editorInit: function () {
      //初始化ace
      require("brace/ext/language_tools");
      require("brace/mode/python");
      require("brace/snippets/python");
      require("brace/theme/eclipse");
    },
    openAmendDialog() {
      // 如果在wrongBook页面，通过事件通知父组件
      if (this.isWrongBookPage) {
        this.$emit('openAmendDialog');
      } else {
        this.amendDialogShow = true;
      }
    },
    closeAmendDialog() {
      this.amendDialogShow = false;
    },
    openAnalysisDialog() {
      // 如果在wrongBook页面，通过事件通知父组件
      if (this.isWrongBookPage) {
        this.$emit('openAnalysisDialog');
      } else {
        this.analysisDialogShow = true;
      }
    },
    closeAnalysisDialog() {
      this.analysisDialogShow = false;
    },
    collectQuestion() {
      this.$message({
        type: 'success',
        message: '收藏成功！'
      });
    },
    // 处理文件选择变化
    handleFileChange(file, fileList) {
      // 检查文件大小（不能超过50MB）
      const maxSize = 30 * 1024 * 1024; // 50MB in bytes
      if (file.raw && file.raw.size > maxSize) {
        this.$message({
          type: 'error',
          message: '文件大小不能超过30MB！'
        });
        // 清空文件列表
        this.fileList = [];
        this.selectedFile = null;
        return;
      }

      // 只保留最新的一个文件
      this.fileList = [file];
      this.selectedFile = file.raw;

      // 自动上传文件
      this.submitUpload();
    },
    // 提交上传
    submitUpload() {
      if (!this.selectedFile) {
        this.$message({
          type: 'warning',
          message: '请选择要上传的文件！'
        });
        return;
      }

      // 如果存在之前的文件，则先删除
      if (this.previousFileId) {
        // 直接调用删除接口，不管删除结果
        request.delete(`/wancode/exam/userAnswerFile/delete/${this.previousFileId}`)
            .then(() => {
              console.log('旧文件删除成功');
            })
            .catch(error => {
              console.error('删除旧文件失败:', error);
            });

        // 清除本地文件
        this.fileList = [];
      }

      // 上传新文件
      this.uploadNewFile();
    },

    // 上传新文件
    uploadNewFile() {
      // 设置上传状态为正在上传
      this.isUploading = true;

      // 创建FormData对象
      const formData = new FormData();
      formData.append('file', this.selectedFile);
      formData.append('questionId', this.questionBody.id);
      formData.append('itemOrder', this.subjectId);

      // 发送上传请求
      request.post('/wancode/exam/userAnswerFile/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(response => {
        this.handleUploadSuccess(response);
      }).catch(error => {
        this.handleUploadError(error);
      }).finally(() => {
        // 无论成功还是失败，都清除上传状态
        this.isUploading = false;
      });
    },
    // 上传成功处理
    handleUploadSuccess(response) {
      this.$message({
        type: 'success',
        message: '文件上传成功！'
      });

      this.uploadedFile = response.data;

      // 保存上传成功的文件ID，用于下次上传时删除
      if (response.data && response.data.id) {
        this.previousFileId = response.data.id;
      }

      // 如果有需要，可以在这里触发父组件的changed事件
      this.$emit("changed", {
        id: this.subjectId,
        questionId: this.questionBody.id,
        content: '',
        userAnswerFileId: response.data ? response.data.id : null,
        contentArray: [],
        itemOrder: this.subjectId
      });
    },
    // 上传失败处理
    handleUploadError(error) {
      this.$message({
        type: 'error',
        message: '文件上传失败，请重试！'
      });
      console.error('文件上传失败:', error);
    },

    // 删除文件
    deleteFile() {
      if (this.uploadedFile && this.uploadedFile.id) {
        // 调用删除接口
        request.delete(`/wancode/exam/userAnswerFile/delete/${this.uploadedFile.id}`)
            .then(() => {
              this.$message({
                type: 'success',
                message: '文件删除成功！'
              });

              // 清除本地文件信息
              this.uploadedFile = null;
              this.previousFileId = null;
              this.fileList = [];
            })
            .catch(error => {
              this.$message({
                type: 'error',
                message: '文件删除失败，请重试！'
              });
              console.error('文件删除失败:', error);
            });
      }
    },

    // 处理文件移除
    handleFileRemove(file, fileList) {
      // 更新文件列表
      this.fileList = fileList;

      // 如果有之前上传的文件ID，则调用删除接口
      if (this.previousFileId) {
        // 调用删除接口
        request.delete(`/wancode/exam/userAnswerFile/delete/${this.previousFileId}`)
            .then(() => {
              this.$message({
                type: 'success',
                message: '文件删除成功！'
              });

              // 清除本地文件信息
              this.uploadedFile = null;
              this.previousFileId = null;
            })
            .catch(error => {
              this.$message({
                type: 'error',
                message: '文件删除失败，请重试！'
              });
              console.error('文件删除失败:', error);
            });
      }
    }
  },
  watch: {
    myAnswer: {
      handler: function (n, o) {
        if (this.haveAnswer) {

        } else {
          // Scratch 编程题初始化时不触发 changed 事件
          if (this.isInitializing && this.questionBody.langCode === 'Scratch') {
            return
          }
          if (this.myAnswer === "") {
            this.$emit("unchanged", {
              id: this.subjectId,
              name: this.myAnswer
            })
          } else {
            console.log("mumu", this.myAnswer)
            this.$emit("changed", {
              id: this.subjectId,
              name: this.radio,
              questionId: this.questionBody.id,
              userAnswerFileId: this.uploadedFile ? this.uploadedFile.id : null,
              content: this.myAnswer,
              contentArray: [],
              itemOrder: this.subjectId
            })
          }
        }
      },
      deep: true
    },
    content: {

      handler: function (n, o) {
        if (this.haveAnswer) {

        } else {
          // console.log(this.content)
          if (this.content == "") {
            this.$emit("unchanged", {
              id: this.subjectId,
              name: this.content
            })
          } else {
            this.$emit("changed", {
              id: this.subjectId,
              name: this.radio,
              questionId: this.questionBody.id,
              content: this.content,
              contentArray: [],
              itemOrder: this.subjectId
            })
          }
        }
      },
      deep: true
    }
  },
  data() {
    return {
      amendDialogShow: false,
      analysisDialogShow: false,
      textarea: "",
      content: "",
      myAnswer: "",
      fileList: [],
      selectedFile: null,
      previousFileId: null,
      uploadedFile: null,
      isUploading: false,
      monacoEditor: null, // Monaco Editor 实例
      answerEditor: null, // 参考答案 Monaco Editor 实例
      isInitializing: true, // 标记是否正在初始化，防止触发 changed 事件
      uploadData: {
        questionId: this.questionBody.id,
        itemOrder: this.subjectId
      }
    }
  }
}
</script>
<style>

</style>

<style lang="scss" scoped>
/* 紧凑模式下减少卡片左右间距（试卷页面） */
.compact-mode ::v-deep .el-card__header {
  padding-left: 0px;
  padding-right: 10px;
  border-bottom: none;
}

.compact-mode ::v-deep .el-card__body {
  padding-left: 0px;
  padding-right: 10px;
}

/* ========== Monaco Editor 工具栏样式 ========== */
.monaco-editor-wrapper {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
}

.editor-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 32px;
  padding: 0 12px;
  background: linear-gradient(135deg, #2d2d2d 0%, #1e1e1e 100%);
  border-bottom: 1px solid #3d3d3d;
}

.toolbar-left {
  display: flex;
  align-items: center;
}

.lang-tag {
  padding: 2px 10px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  color: #e0e0e0;
  font-family: 'Consolas', 'Monaco', monospace;
}

.toolbar-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.toolbar-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  font-size: 12px;
  color: #b0b0b0;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.2s ease;

  i {
    font-size: 13px;
  }

  &:hover {
    color: #fff;
    background: rgba(255, 255, 255, 0.1);
  }
}

.toolbar-btn.run-btn {
  color: #67c23a;

  &:hover {
    background: rgba(103, 194, 58, 0.2);
  }

  &.disabled {
    color: #555;
  }
}

.toolbar-btn.disabled {
  color: #555;
  cursor: not-allowed;

  &:hover {
    color: #555;
    background: transparent;
  }
}

.monaco-editor-container {
  height: 350px;
  min-height: 350px;
  width: 100%;
  transition: height 0.2s ease;
}

/* Scratch 参考答案样式 */
.scratch-answer {
  padding: 16px;
  background-color: #f5f7fa;
  border-radius: 8px;
  font-size: 14px;
  line-height: 1.6;
  color: #606266;
  word-break: break-word;
}

/* Monaco Editor 整体圆角 */
::v-deep .monaco-editor {
  border-radius: 0 0 8px 8px;
}

::v-deep .monaco-editor .overflow-guard {
  border-radius: 0 0 8px 8px;
}

:deep(.editor-content-view pre) {
  word-wrap: normal;
  font-family: Consolas, Monaco, Andale Mono, Ubuntu Mono, monospace;
  background-color: #F5F2F0;
  /*border: 3px solid #ccc;*/
  border-radius: 5px;
  padding: 10px 10px;
  margin-top: 5px;
  /*margin-bottom: 10px;*/
  overflow-x: auto;
  font-size: 16px;
  line-height: 1.5;
  min-width: 750px;
  tab-size: 4;

  br {
    display: none;
  }
}

/* pre 标签复制按钮样式 */
:deep(.pre-wrapper) {
  position: relative;

  .pre-copy-btn {
    position: absolute;
    top: 4px;
    right: 4px;
    display: flex;
    align-items: center;
    gap: 2px;
    padding: 2px 6px;
    font-size: 11px;
    color: #909399;
    background: rgba(255, 255, 255, 0.7);
    border: none;
    border-radius: 3px;
    cursor: pointer;
    transition: all 0.2s ease;
    z-index: 10;
    opacity: 0.6;

    i {
      font-size: 11px;
    }

    &:hover {
      color: #409eff;
      background: rgba(255, 255, 255, 0.95);
      opacity: 1;
    }
  }
}

:deep(.editor-content-view pre) {
  /*font-family: monospace;*/
  /*background-color: #eee;*/
  /*padding: 5px;*/
  /*border-radius: 3px;*/
}

/* 确保sub和sup标签被正确显示 */
::v-deep sub {
  vertical-align: sub;
  font-size: smaller;
}

::v-deep sup {
  vertical-align: super;
  font-size: smaller;
}


.subjectName {
  display: flex;
  align-items: baseline;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  line-height: 1.65;

  .question-number {
    font-size: 18px;
    font-weight: 600;
    color: #303133;
    margin-right: 6px;
    flex-shrink: 0;
    line-height: 1.65;
  }

  .question-title-content {
    font-size: 18px;
    color: #303133;
    line-height: 1.65;
    letter-spacing: 0.3px;
    flex: 1;

    :deep(p) {
      margin: 0.5em 0;
      line-height: 1.65;
    }

    :deep(p:first-child) {
      margin-top: 0;
    }
  }

  p {
    font-size: 18px;
  }
}


.content {
  font-size: 14px;
  margin-top: 20px;
  color: #808080;
  display: flex;

  span {
    font-weight: 600;
    color: #000;
    line-height: 20px;
  }
}

.content2 {
  font-size: 14px;
  color: #808080;
  display: flex;

}

.upload-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
  padding: 5px 0;
}

.uploaded-file-info {
  padding: 10px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background-color: #f9f9f9;
}

.unanswered-file-info {
  border-color: #f3d19e;
  background-color: #fdf6ec;

  .file-info i,
  .file-name {
    color: #e6a23c;
  }
}

.file-display {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 5px;
}

.file-display:hover {
  border-color: #409eff;
}

.file-info {
  display: flex;
  align-items: center;
}

.file-info i {
  font-size: 18px;
  color: #409eff;
  margin-right: 8px;
}

.file-name {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 10px;
}

.download-link {
  color: #409eff;
  text-decoration: none;
  font-size: 14px;
}

.download-link:hover {
  text-decoration: underline;
}

.answer-style {
  position: relative;
  border: 1px solid #eee;
  border-radius: 5px;
  line-height: 24px;
  margin: 20px 0 10px 0;
  padding-left: 15px;
  font-size: 15px;
  color: #555;
  background: #fcfcfc;

  // 确保编辑器工具栏样式不受父元素影响
  .monaco-editor-wrapper {
    font-size: 12px;
    line-height: normal;
  }

  .action-buttons {
    position: absolute;
    right: 10px;
    top: 10px;
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .action-btn {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 4px 12px;
    border-radius: 4px;
    font-size: 13px;
    cursor: pointer;
    transition: all 0.2s ease;
    color: #409EFF;
    border: 1px solid #d9ecff;
    background: #ecf5ff;

    i {
      font-size: 13px;
    }

    &:hover {
      background: #409EFF;
      color: #ffffff;
      border-color: #409EFF;
    }
  }

}
</style>
